import mendeleev from "@/urls/mendeleev"
import {
  sendGetRequest, sendPostRequestFile
} from "@/helper/requests"

const state = {
  student: {
    currentUrl: null,
    items: [],
    loading: false,
    count: 0,
    detail: [],
    next: null,
    prev: null,
    error: null,
  }
}

const getters = {
  getStudent: state => state.student.items,
  getStudentCount: state => state.student.count,
  getStudentCurrentUrl: state => state.student.currentUrl,
  getStudentNext: state => state.student.next,
  getStudentPrev: state => state.student.prev,
  getStudentDetail: state => state.student.detail,
  isLoadingStudent: state => state.student.loading,
  saveStudentError: state => state.student.error,
}

const actions = {
  loadStudent: ({ commit, getters }, { url, urlAppend, finalizer = () => {}, catcher = () => {} }) => {
    if (!url) {
      url = mendeleev.USER.MEMBER.STUDENT.LIST()
      if (urlAppend) url = urlAppend(url)
    }
    if (!getters.isLoadingStudent) {
      commit('SET_STUDENT_LOADING')
      sendGetRequest(
        url, (data, url) => {
          commit('SET_STUDENT', data.results)
          commit('SET_STUDENT_COUNT', data.count)
          commit('SET_STUDENT_CURRENT_URL', url)
          commit('SET_STUDENT_NEXT_URL', data.next)
          commit('SET_STUDENT_LOADING_END')
          finalizer(data, url)
        }, (data, url) => {
          commit('SET_STUDENT_LOADING_END')
          commit('SAVE_STUDENT_ERROR', data)
          catcher(data, url)
        }
      )
    }
  },
  createStudent: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.MEMBER.STUDENT.CREATE()
    commit('SET_STUDENT_LOADING')
    sendPostRequestFile(
      url, data, (data, url) => {
        commit('SET_STUDENT_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_STUDENT_LOADING_END')
        catcher(data, url)
      }
    )
  },
  simplifiedCreateStudent: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.MEMBER.SIMPLIFIED.STUDENT()
    commit('SET_STUDENT_LOADING')
    sendPostRequestFile(
      url, data, (data, url) => {
        commit('SET_STUDENT_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_STUDENT_LOADING_END')
        catcher(data, url)
      }
    )
  },
  updateStudent: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.MEMBER.STUDENT.UPDATE()
    commit('SET_STUDENT_LOADING')
    sendPostRequestFile(
      url, data, (data, url) => {
        commit('SET_STUDENT_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_STUDENT_LOADING_END')
        catcher(data, url)
      }
    )
  },
  // loadStudentDetail: ({commit}, {url, id, finalizer=()=>{}, catcher=()=>{}}) => {
  //   if (!url) url = url = mendeleev.USER.STUDENT.STUDENT.DETAIL(id)
  //   sendGetRequest(
  //     url, (data, url) => {
  //       commit('SET_STUDENT_DETAIL', data);
  //       finalizer(data, url);
  //     }, (data, url) => {
  //       commit('SAVE_STUDENT_ERROR', data);
  //       catcher(data, url);
  //     }
  //   )
  // },
}

const mutations = {
  SET_STUDENT: (state, value) => {
    state.student.items = value
  },
  SET_STUDENT_DETAIL: (state, value) => {
    state.student.detail = value
  },
  SET_STUDENT_COUNT: (state, value) => {
    state.student.count = value
  },
  SET_STUDENT_CURRENT_URL: (state, value) => {
    state.student.currentUrl = value
  },
  SET_STUDENT_NEXT_URL: (state, value) => {
    state.student.next = value
  },
  SET_STUDENT_PREV_URL: (state, value) => {
    state.student.prev = value
  },
  SET_STUDENT_LOADING: (state) => {
    state.student.loading = true
  },
  SET_STUDENT_LOADING_END: (state) => {
    state.student.loading = false
  },
  SAVE_STUDENT_ERROR: (state, error) => {
    state.student.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
